(() => {
  const STORAGE_KEY = 'olivercabell-cookie-consent-choice';

  function readDismissal() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function saveDismissal(choice) {
    try {
      window.localStorage.setItem(STORAGE_KEY, choice);
    } catch (error) {
      // A storage-restricted browser can still dismiss the current banner.
    }
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-cookie-banner]').forEach((banner) => {
      if (banner.dataset.cookieInitialized) return;
      banner.dataset.cookieInitialized = 'true';

      const dismiss = (choice) => {
        saveDismissal(choice);
        banner.hidden = true;
        banner.setAttribute('aria-hidden', 'true');
      };

      banner.setAttribute('aria-hidden', 'true');
      if (!readDismissal()) {
        banner.hidden = false;
        banner.setAttribute('aria-hidden', 'false');
      }

      banner.addEventListener('click', (event) => {
        const control = event.target.closest('[data-cookie-dismiss]');
        if (control) dismiss(control.dataset.cookieDismiss);
      });
    });
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  initialize();
})();
